import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import rp, { AppComponent, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { IOBrowserAdapter } from "../adapters";

@customElement('rp-io-sidebar')
export class Sidebar extends AppComponent {

	static styles = [style];

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: IOBrowserAdapter;
    get browserAdapter() { 
        if (!this._browserAdapter) {
            this._browserAdapter = new IOBrowserAdapter();
        }
        return this._browserAdapter;
    }
	
	refresh = () => {
		this.browser.refresh();
	}

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.IOBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			IOBrowser: this.browser?.getState(),
		}
	}

	_onChangeState = () => {
		this.dispatchStateEvent();
	}

	_onSelect = (e: BrowserEvent) => {
		if (e.node.level > 0) {
			rp.host.open(e.node.key, {title: e.node.value});
		}
	}

	render = () => html`
		<div class="body">
			<rp-browser id="browser" .adapter="${this.browserAdapter}" @browser.select="${this._onSelect}"></rp-browser>
		</div>
	`;

}
